import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import type { GlobalUspItemModel } from 'autogen/swagger/all';
import WhenBreakpoint from 'helpers/WhenBreakpoint';
import { rem } from 'modules/helpers/style';
import DesktopUSPHeader from './components/DesktopUSPHeader';
import MobileUSPHeader from './components/MobileUSPHeader';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    background-color: ${ColorNordicGrey4};
    height: ${rem(32)};
    overflow: hidden;
    font-size: ${rem(12)};
`;

export type IUSPHeader = {
    uspMobileItems: GlobalUspItemModel[];
    uspDesktopItems: GlobalUspItemModel[];
};

function cleanUSPs(usps: GlobalUspItemModel[]) {
    return usps.filter((usp) => !!usp.text);
}

export default function USPHeader(props: IUSPHeader) {
    const { uspMobileItems, uspDesktopItems } = props;
    const [show, set] = useState(false);

    useEffect(() => {
        set(true);
    }, []);

    return (
        <Wrapper>
            {show && (
                <>
                    <WhenBreakpoint up="xl" negate removeFromDOM>
                        <MobileUSPHeader usps={cleanUSPs(uspMobileItems)} />
                    </WhenBreakpoint>
                    <WhenBreakpoint up="xl" removeFromDOM>
                        <DesktopUSPHeader usps={cleanUSPs(uspDesktopItems)} />
                    </WhenBreakpoint>
                </>
            )}
        </Wrapper>
    );
}
